// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container__jia8n","quote":"quote_quote___OOfu","author":"quote_author__wbuwS","cta":"quote_cta__gi1ig"};